function activityUrlPc() {
  if (process.env.NODE_ENV === "production") {
    return "https://mk.yybip.com/detail.html"; //正式pc端活动首页
  } else {
    return "https://mkfs.yybip.com/mk-portal-test/detail.html"; //测试pc端活动首页
  }
}
function activityUrlMobile() {
  if (process.env.NODE_ENV === "production") {
    return "https://mkm.yybip.com/"; //正式
  } else {
    return "https://mkm.yybip.com/test/"; //测试
  }
}
function activitySignInUrl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mkm.yybip.com/index.html"; //正式
  } else {
    return "https://mkm.yybip.com/test/index.html"; //测试
  }
}
function activitySignInUrl1() {
  if (process.env.NODE_ENV === "production") {
    return "https://mkm.yybip.com/signin.html"; //正式
  } else {
    return "https://mkm.yybip.com/signin.html"; //测试
  }
}
function qrCodeUrl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mk.yybip.com/t/"; //正式
  } else {
    return "https://mk.yybip.com/t/"; //测试
  }
}
function activeqrCodeUrl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mkm.yybip.com?wxShareType=active&wxShareId="; //正式
  } else {
    return "https://mkm.yybip.com/test/?wxShareType=active&wxShareId="; //测试
  }
}
function featuredqrCodeUrl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mkm.yybip.com?wxShareType=topic&wxShareId="; //正式
  } else {
    return "https://mkm.yybip.com/test/?wxShareType=topic&wxShareId="; //测试
  }
}
function formqrCodeUrl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mkfs.yybip.com/mk-form/submit/mb.html?id="; //正式
  } else {
    return "https://mkfs.yybip.com/mk-form-test/submit/mb.html?id="; //测试
  }
}
function zjurl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mk-api.yybip.com/formbuilder/feiyu/html/page/push"; //正式
  } else {
    return "https://mk-wx.yybip.com/formbuilder/feiyu/html/page/push"; //测试
  }
}
function txurl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mk-api.yybip.com/formbuilder/txqq/html/page/push"; //正式
  } else {
    return "https://mk-wx.yybip.com/formbuilder/txqq/html/page/push"; //测试
  }
}
function bdurl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mk-api.yybip.com/formbuilder/baidu/html/page/push"; //正式
  } else {
    return "https://mk-wx.yybip.com/formbuilder/baidu/html/page/push"; //测试
  }
}
export default {
  //域名
  domainName: "https://mk-api.yybip.com/",
  picDomain: "https://mks.yybip.com/",
  domainName1: "https://mk.yybip.com/",
  activityUrlPc: activityUrlPc(),
  activitySignInUrl: activitySignInUrl(),
  activityUrlMobile: activityUrlMobile(),
  qrCodeUrl: qrCodeUrl(),
  zjurl: zjurl(),
  txurl: txurl(),
  bdurl: bdurl(),
  activeqrCodeUrl: activeqrCodeUrl(),
  formqrCodeUrl: formqrCodeUrl(),
  featuredqrCodeUrl: featuredqrCodeUrl(),
  // 活动分类页面地址
  activeCategory: {
    pcUrl: (id, name) => {
      if (process.env.NODE_ENV === "production") {
        return (
          "https://mk.yybip.com/type.html?type=category&typeid=" +
          id +
          "&typename=" +
          encodeURI(name)
        ); //正式
      } else {
        return (
          "https://mkfs.yybip.com/mk-portal-test/type.html?type=category&typeid=" +
          id +
          "&typename=" +
          encodeURI(name)
        ); //测试
      }
    },
    h5Url: (id, name) => {
      if (process.env.NODE_ENV === "production") {
        return (
          "https://mkm.yybip.com/index.html?wxShareType=category&id=" +
          id +
          "&name=" +
          encodeURI(name)
        ); //正式
      } else {
        return (
          "https://mkm.yybip.com/test/index.html?wxShareType=category&id=" +
          id +
          "&name=" +
          encodeURI(name)
        ); //测试
      }
    },
    wxappUrl: (id, name) => {
      return "pages/index/index?type=category&id=" + id + "&name=" + name;
    }
  },
  weixin: {
    miniprogram: {
      h5Url: path => {
        return (
          "https://mk.yybip.com/miniprogramurl.html?miniprogrampath=" +
          encodeURIComponent(path)
        );
      }
    }
  }
};
